/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Emailssettingsdescription2Inputs */

const en_emailssettingsdescription2 = /** @type {(inputs: Emailssettingsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we send you by e-mail.`)
};

const de_emailssettingsdescription2 = /** @type {(inputs: Emailssettingsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was wir dir per E-Mail schicken.`)
};

/**
* | output |
* | --- |
* | "What we send you by e-mail." |
*
* @param {Emailssettingsdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const emailssettingsdescription2 = /** @type {((inputs?: Emailssettingsdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emailssettingsdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_emailssettingsdescription2(inputs)
	return de_emailssettingsdescription2(inputs)
});
export { emailssettingsdescription2 as "emailsSettingsDescription" }